<template>

    <div class="full-height" :class="['bg-' + color]">

        <v-header :title="title" :title-color="titleColor" :icon="icon">
            <template slot="right">
                <slot name="right"></slot>
            </template>
        </v-header>

        <slot></slot>

    </div>

</template>


<script>
    import {QIcon} from 'quasar-framework'

    export default {
        name: 'Column',

        props: {
            title: String,
            titleColor: {
                type: String,
                default: 'white'
            },
            icon: {
                type: String
            },
            color: {
                type: String,
                default: 'columnn'
            }
        },

        components: {
            QIcon
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Column.vue